import {useTranslation} from "react-i18next";
import {useState} from "react";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Collapse from "react-bootstrap/Collapse";
import Form from "react-bootstrap/Form";

const BoxFiltersMooch = ({filters, show}) => {
    const {t: _Tt} = useTranslation("tables");
    const [selectedCleared, setSelectedCleared] = useState("");

    const onChangeCleared = (e) => {
        const value = e.target.value;
        setSelectedCleared(value);
        if (value) {
            filters.current.chosen.cleared = value;
        } else {
            delete filters.current.chosen.cleared;
        }
    };

    const clearFilters = () => {
        setSelectedCleared("");
        delete filters.current.chosen.cleared;
    };

    return (
        <Collapse in={show}>
            <div id="filter-collapse" className="p-3">
                <div className="row mb-1 d-flex align-items-center">
                    <div className="col pt-3 mt-2" style={{maxWidth: "80px"}}>
                        <Button
                            variant="link"
                            type="button"
                            onClick={clearFilters}
                            title={_Tt("common.clearFilters")}>
                            <FontAwesomeIcon icon="filter-circle-xmark" />{" "}
                        </Button>
                    </div>
                    <div className="col-3">
                        <label style={{fontWeight: "bold"}}>
                            {_Tt("common.cleared")}
                        </label>
                        <Form.Select value={selectedCleared} onChange={onChangeCleared} size="sm">
                            <option value="all">All</option>
                            <option value="false">Not Cleared</option>
                            <option value="true">Cleared</option>
                        </Form.Select>
                    </div>
                    <div className="col pt-3 mt-2">
                        <Button
                            variant="primary"
                            onClick={filters.current.filter}
                            title={_Tt("common.applyFilters")}>
                            <FontAwesomeIcon icon="magnifying-glass" />{" "}
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default BoxFiltersMooch;
